export const rootUrl =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_CYPRESS_TEST === 'true'
    ? 'http://dealers.localhost:3000'
    : `https://${window.location.host}`
export const wsUrl =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_CYPRESS_TEST === 'true'
    ? 'ws://localhost:3000/cable'
    : `wss://${window.location.host}/cable`
export const minBetRise = 50

export const marketApiUrl =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_CYPRESS_TEST === 'true'
    ? 'http://localhost:3005'
    : `https://${window.location.host}`

export const turnstileSiteKey = '0x4AAAAAAEtxt-soRzXHRgjy'
